function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.70208 18.3284H19.0779C19.2427 18.3284 19.402 18.2707 19.5283 18.1656C19.7048 18.0178 23.731 14.5543 23.9765 7.07788H4.24121C3.99665 13.8645 0.288765 17.0544 0.250232 17.0862C0.0243312 17.2771 -0.0587819 17.5889 0.0428476 17.8663C0.143774 18.143 0.406801 18.3284 0.70208 18.3284Z",
  fill: "#FE9900"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.2968 2.85919H19.781V2.15604C19.781 1.76227 19.4716 1.45288 19.0778 1.45288C18.684 1.45288 18.3747 1.76227 18.3747 2.15604V2.85919H14.812V2.15604C14.812 1.76227 14.5026 1.45288 14.1088 1.45288C13.7151 1.45288 13.4057 1.76227 13.4057 2.15604V2.85919H9.8899V2.15604C9.8899 1.76227 9.58051 1.45288 9.18674 1.45288C8.79298 1.45288 8.48359 1.76227 8.48359 2.15604V2.85919H4.9678C4.57404 2.85919 4.26465 3.16858 4.26465 3.56235V5.67182H23.9999V3.56235C23.9999 3.16858 23.6905 2.85919 23.2968 2.85919Z",
  fill: "#FE9900"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.4312 19.2438C20.0494 19.5617 19.5702 19.7348 19.0778 19.7348H4.26465V21.8442C4.26465 22.2329 4.57915 22.5474 4.9678 22.5474H23.2968C23.6854 22.5474 23.9999 22.2329 23.9999 21.8442V13.962C22.6442 17.288 20.7525 18.9749 20.4312 19.2438Z",
  fill: "#FE9900"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.f69f8c44.svg";
export { ForwardRef as ReactComponent };